import { Component, OnInit, OnDestroy, Inject, ElementRef, Renderer2 } from '@angular/core';
import { BaseAuthService } from '@shared/utils/base-auth';
import { Subject, take, takeUntil } from 'rxjs';
import { AppConfig } from '@shared/utils/app-config';
import { Router, NavigationEnd, RouterState, ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'feature-page-layout-google-analytics-tracking',
    templateUrl: './google-analytics-tracking.component.html',
    styleUrls: ['./google-analytics-tracking.component.css'],
    standalone: false
})
export class GoogleAnalyticsTrackingComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();

  constructor(
    public baseAuthService: BaseAuthService,
    private appConfig: AppConfig,
    private renderer2: Renderer2,
    private el: ElementRef,
    private titleService: Title,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {}

  ngOnInit(): void {
    this.baseAuthService
      .getCurrentBaseUser()
      .pipe(take(1), takeUntil(this.ngUnsubscribe))
      .subscribe((x) => {
        if (this.appConfig.production && this.appConfig.tracking.analyticsId) {
          const googleTagManagerScript = this.renderer2.createElement('script');
          googleTagManagerScript.async = true;
          googleTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.appConfig.tracking.analyticsId}`;
          this.renderer2.appendChild(this.el.nativeElement, googleTagManagerScript);

          const googleAnalyticsScript = this.renderer2.createElement('script');
          googleAnalyticsScript.text = `     
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
          
            var currentUserId =  '${x?.uid != null ? x.uid : null}' ;
            var currentUserEmail =  '${x?.email != null ? x.email : null}' ;
          
            gtag("set", { "user_id": currentUserId });
          
            gtag("set", { "user_email": currentUserEmail });
          
            gtag("js", new Date());
            gtag("config", '${this.appConfig.tracking.analyticsId}', {
              "user_email": currentUserEmail,
            });
          `;
          this.renderer2.appendChild(this.el.nativeElement, googleAnalyticsScript);
        }
      });
    this.handleRouteEvents();
  }

  handleRouteEvents(): void {
    if (this.appConfig.production && this.appConfig.tracking.analyticsId) {
      this.router.events.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event) => {
        if (event instanceof NavigationEnd) {
          const title = this.getTitle(this.router.routerState, this.router.routerState.root).join('-');
          this.titleService.setTitle(title);
          gtag('event', 'page_view', {
            page_title: title,
            page_path: event.urlAfterRedirects,
            page_location: this.document.location.href,
          });
        }
      });
    }
  }

  getTitle(state: RouterState, parent: ActivatedRoute): string[] {
    const data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data['title']) {
      data.push(parent.snapshot.data['title']);
    }
    if (state && parent && parent.firstChild) {
      data.push(...this.getTitle(state, parent.firstChild));
    }

    return data;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}

declare function gtag(...args: unknown[]): void;
